export function pointInLine(p, p1, p2, tolerance) {
	function distanceToSegment() {
		let dx;
		let dy;

		if (p2.x === p1.x && p2.y === p1.y) {
			dx = p.x - p1.x;
			dy = p.y - p1.y;
		} else {
			dx = p2.x - p1.x;
			dy = p2.y - p1.y;

			const projection = ((p.x - p1.x) * dx + (p.y - p1.y) * dy) / (dx * dx + dy * dy);

			if (projection < 0) {
				dx = p.x - p1.x;
				dy = p.y - p1.y;
			} else if (projection > 1) {
				dx = p.x - p2.x;
				dy = p.y - p2.y;
			} else {
				dx = p.x - (p1.x + projection * dx);
				dy = p.y - (p1.y + projection * dy);
			}
		}

		return Math.sqrt(dx * dx + dy * dy);
	};

	if ((p.x === p1.x && p.y === p1.y) || (p.x === p2.x && p.y === p2.y)) {
		return true;
	}

	return distanceToSegment() <= tolerance + 1;
}

/**
 * Draws a dashed line.
 * @param {CanvasRenderingContext2D} ctx Canvas context.
 * @param {number} x Starting line horizontal position in pixels.
 * @param {number} y Starting line vertical position in pixels.
 * @param {number} x2 Ending line horizontal position in pixels.
 * @param {number} y2 Ending line vertical position in pixels.
 * @param {number[]} [da=[10, 5]] Optional array of dash offsets.
 */
export function dashedLine(ctx, x, y, x2, y2, da = [10, 5]) {
	ctx.save();

	const dx = x2 - x;
	const dy = y2 - y;
	const len = Math.sqrt(dx * dx + dy * dy);
	const rot = Math.atan2(dy, dx);

	ctx.translate(x, y);
	ctx.moveTo(0, 0);
	ctx.rotate(rot);

	const dashCount = da.length;
	let dashIndex = 0;
	let draw = true;
	let progress = 0;

	while (progress < len) {
		progress += da[dashIndex++ % dashCount];

		if (progress > len) {
			progress = len;
		}

		if (draw) {
			ctx.lineTo(progress, 0);
		} else {
			ctx.moveTo(progress, 0);
		}

		draw = !draw;
	}

	ctx.restore();
}

/*TOUCH FUNCTIONS*/

/**
 * Double tap function reset the axes of the chart if canvas is double tapped.
 */
export function doubleTap(chart) {
	var canvas = chart.canvas
	var timeout
	var lastTap = 0
	canvas.addEventListener("touchend", e => {
		var currentTime = new Date().getTime()
		var tapLength = currentTime - lastTap
		clearTimeout(timeout)
		if (tapLength < 600 && tapLength > 100) {
			chart.zoom.reset()
			chart.draw()
		} else {
			timeout = setTimeout(() => {
				clearTimeout(timeout)
			}, 600)
		}
		lastTap = currentTime
		e.preventDefault()
	})
}
